import { SET_CMS_CTX } from './types'
import { buildPrismicContext } from 'front-end-core/services/CMSService'
import { AppDispatch } from 'redux/store';
import { CMSCtx } from '../../interfaces/cms';

const cmsConfig = {
  endpoint: process.env.CMS_API_ENDPOINT
}

export const setCmsCtx = () => {
  return (dispatch:AppDispatch, _: any) => {
    const ctx: CMSCtx = buildPrismicContext(cmsConfig)
    dispatch({ type: SET_CMS_CTX, ctx })
  }
}
